import docIcon from "../../assets/img/docIcon02.svg";
import Cancelimg from "../../assets/img/cancel-01.svg";
import useTranslator from "../../hooks/useTranslator";
import styles from "./approvedModal.module.css";

const ApprovedModal = ({
  showPopup,
  setShowApprovalPopup,
  onhandleManualUpload,
  availableClaveDocs,
  handleInitiateClave,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      {showPopup && (
        <div className={`approvedModal ${styles.overlay}`}>
          <div
            className={`popup-content2 popup-content bg-white saveTimePopup ${styles.surface}`}
          >
            <div className={styles.header}>
              <h4>{_t("saveTimeGetApprovedFaster")}</h4>
              <button
                type="button"
                className={styles.closeButton}
                onClick={onhandleManualUpload}
                aria-label={_t("close")}
              >
                <img src={Cancelimg} alt="" className="canceicon" />
              </button>
            </div>

            <div className={styles.documentList}>
              {availableClaveDocs.map((name) => (
                <div className={styles.documentRow} key={name}>
                  <img className="docoment-img2" src={docIcon} alt="" />
                  <p className="staticdata_div">{_t(name, "", "fixed")}</p>
                </div>
              ))}
            </div>

            <p className={`fw-medium staticdata_div ${styles.subtitle}`}>
              {_t(
                "landlordsPreferToGetTenantDocumentsViaClavepinItHelpsLandlordsToTrustYourProfileAndMakeYourProfileStrongerAmongstOthers"
              )}
            </p>

            <div className={styles.actions}>
              <button
                type="button"
                className="btnNext btnnextpre"
                onClick={onhandleManualUpload}
              >
                {_t("keepUploadingManually")}
              </button>
              <button
                type="button"
                className="btnNext greenHover"
                onClick={() => {
                  handleInitiateClave();
                  setShowApprovalPopup(false);
                }}
              >
                {_t("getFromClavepin")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ApprovedModal;
